import script from "./editMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./editMenu.vue?vue&type=script&setup=true&lang=js"

import "./editMenu.vue?vue&type=style&index=0&id=3b034e04&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b034e04"]])

export default __exports__